export const ResponderOptions = [
  { id: 1, value: "open", label: "Open" },
  { id: 2, value: "close", label: "Close" },
];

export const InitiatorOptions = [
  { id: 1, value: "open", label: "Open" },
  { id: 2, value: "close", label: "Close" },
];
